import { useQuery } from '@tanstack/react-query'
import { fetchProjectUpdates } from '../api/projectUpdatesApi'

export default function ProjectUpdatesView({ projectId }) {
  const { data: updates = [], isLoading } = useQuery({
    queryKey: ['project-updates', projectId],
    queryFn: () => fetchProjectUpdates(projectId),
    enabled: !!projectId,
  })

  const formatDate = (dateString) => {
    const date = new Date(dateString)
    return date.toLocaleDateString('en-NZ', {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
    })
  }

  const formatTime = (dateString) => {
    const date = new Date(dateString)
    return date.toLocaleTimeString('en-NZ', {
      hour: '2-digit',
      minute: '2-digit',
    })
  }

  if (isLoading) {
    return (
      <div className="animate-pulse space-y-4">
        <div className="h-32 bg-secondary-100 rounded" />
        <div className="h-32 bg-secondary-100 rounded" />
      </div>
    )
  }

  if (updates.length === 0) {
    return (
      <div className="text-center py-8 text-secondary-600">
        <p>No updates yet. Check back later for project updates from the developer.</p>
      </div>
    )
  }

  return (
    <div className="space-y-4">
      {updates.map((update) => (
        <div
          key={update.id}
          className="p-6 rounded-lg border border-secondary-200 bg-white"
        >
          <div className="flex-1 mb-3">
            <h4 className="font-semibold text-secondary-900 text-lg mb-1">
              {update.title}
            </h4>
            <div className="text-sm text-secondary-500">
              {formatDate(update.created_at)} at {formatTime(update.created_at)}
            </div>
          </div>
          <p className="text-secondary-700 whitespace-pre-wrap">{update.content}</p>
        </div>
      ))}
    </div>
  )
}
